var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTodoLine = function SvgTodoLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17 3h2.7a.9.9 0 0 1 .9.9v16.2a.9.9 0 0 1-.9.9H5.3a.9.9 0 0 1-.9-.9V3.9a.9.9 0 0 1 .9-.9H8V1.2h1.8V3h5.4V1.2H17zm0 1.8v1.8h-1.8V4.8H9.8v1.8H8V4.8H6.2v14.4h12.6V4.8zM8 8.4h9v1.8H8zM8 12h9v1.8H8z"
  })));
};
export default SvgTodoLine;